export default __webpack_public_path__ + "static/media/SAL4.ed905294.jpg";